import { Alert, Col, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { postFile } from "../../../../utils/fetch";
import { URL_FILES_OP } from "../../../../constants/url";

export const CargarDocumentos = ({ setListaDocumentos, setLoading }) => {
  const _URL_DEV = `${URL_FILES_OP}/CargaPago`;

  const beforeUpload = (file, fileList) => {
    setLoading(true);
    return true;
  };

  const handleChange = ({ file, fileList }) => {
    const completed = fileList.filter(
      (f) => f.status === "done" || f.status === "error"
    ).length;
    if (completed === fileList.length && fileList.length > 0) {
      setLoading(false);
    }
  };
  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Cargar Documentos</div>
    </button>
  );

  return (
    <Col span={24} style={{ margin: "10px", border: 10 }}>
      <Alert
        style={{marginBottom: 20}}
        type="info"
        message="Se pueden cargar multiples documentos, ejemplo de documento: 2541254.pdf"
      />

      <Upload
        customRequest={async ({ file, onSuccess, onError }) => {
          try {
            const formData = new FormData();
            formData.append("file", file);
            const response = await postFile(`${_URL_DEV}`, formData);
            console.log(response);
            if (response.code !== 0) {
              setListaDocumentos((prev) => [
                ...prev,
                { name: file.name, msg: response.error, ok: false },
              ]);
              onError("Error al cargar la imagen");
            } else {
              setListaDocumentos((prev) => [
                ...prev,
                { name: file.name, msg: "ok", ok: true },
              ]);
              onSuccess("Archivo subido con éxito");
            }
          } catch (err) {
            onError(err);
          }
        }}
        listType="picture-card"
        onChange={handleChange}
        multiple={true}
        showUploadList={false}
        beforeUpload={beforeUpload}
      >
        {uploadButton}
      </Upload>
    
    </Col>
  );
};
